import StickySidebar from 'sticky-sidebar-v2';

export default () => {
    const container = document.querySelectorAll('.blur-slide');

    if (!container) {
        return;
    }

    for (const el of container) {
        const images = Array.prototype.slice.call(el.querySelectorAll('.blur-slide__image'));
        const text = Array.prototype.slice.call(el.querySelectorAll('.blur-slide__text .wysiwyg'));
        const reverseText = text.slice().reverse();
        let sidebar;

        const updateImages = (index) => {
            let hiddenImages = [];
            if (index > 0) {
                hiddenImages = images.slice(0, index);
            }
            const shownImages = images.slice(index, images.length);

            for (let i = 0; i < hiddenImages.length; i++) {
                hiddenImages[i].style.opacity = 0;
                hiddenImages[i].style.filter = 'none';
                hiddenImages[i].style.transform = 'scale(1.5) translate(-10%, -10%)';
            }

            for (let i = 0; i < shownImages.length; i++) {
                if (i === 0) {
                    shownImages[i].style.opacity = 1;
                    shownImages[i].style.filter = 'none';
                    shownImages[i].style.transform = 'scale(1)';
                } else {
                    shownImages[i].style.opacity = 1 - i * 0.3;
                    shownImages[i].style.filter = 'blur(' + i * 3 + 'px)';
                    shownImages[i].style.transform =
                        'scale(' + (1 - i * 0.23) + ') translate(' + i * 11 + '%, ' + i * 8 + '%)';
                }
            }
        };

        const handleScroll = () => {
            let activeIndex = reverseText.length - 1;
            for (let i = 0; i < reverseText.length; i++) {
                if (reverseText[i].getBoundingClientRect().top < window.innerHeight / 1.5) {
                    activeIndex = i;
                    break;
                }
            }
            activeIndex = reverseText.length - activeIndex - 1;

            updateImages(activeIndex);
        };

        const handleResize = (query) => {
            if (query.matches) {
                if (sidebar && typeof sidebar.destroy !== undefined) {
                    window.removeEventListener('scroll', handleScroll);
                    sidebar.destroy();
                }
            } else {
                window.addEventListener('scroll', handleScroll);
                sidebar = new StickySidebar(el.querySelector('.blur-slide__column--left'), {
                    topSpacing: document.querySelector('.header').offsetHeight + 20,
                    bottomSpacing: 0,
                    containerSelector: '.blur-slide__columns',
                    innerWrapperSelector: '.blur-slide__images',
                });
            }
        };

        const query = window.matchMedia('(max-width: 768px)');
        handleResize(query);
        query.addListener(handleResize);
        updateImages(0);
    }
};
